import { Statuses } from '../types';

export const statuses: Statuses = {
  Alive: '#55CC44',
  Dead: '#D63D2E',
  unknown: '#9E9E9E',
};
